import React from "react";

function AdditionalCompany({ stateObj, setStateObj, UpdateProfile }) {
  return (
    <div className="row">
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label  className="form-label w-100" htmlFor="linkedin">
            Company Description:
            <small style={{ float: "right" }}>
              {stateObj.companydescription?.length || 0} / 2000
            </small>
          </label>
          <textarea
            id="aboutyourself"
            name="aboutyourself"
            className="form-control"
            style={{ minHeight: 100 }}
            onChange={(e) => {
              if (e.target.value.length <= 2000)
                setStateObj({
                  ...stateObj,
                  companydescription: e.target.value,
                });
            }}
            value={stateObj.companydescription}
          ></textarea>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label  className="form-label w-100">
          Specialisation / Expertise:
            <small style={{ float: "right" }}>
              {stateObj.skills?.length || 0} / 250
            </small>
          </label>
          <textarea
            className="form-control"
            readOnly={stateObj.activestatus !== "True"}
            style={{ minHeight: 100 }}
            onChange={(e) => {
              if (
                e.target.value.length <= 250 &&
                stateObj.activestatus === "True"
              )
                setStateObj({ ...stateObj, skills: e.target.value });
            }}
            value={stateObj.skills}
            placeholder={
              stateObj.activestatus !== "True" ? "Subscribe to Enter" : "Specialisation / Expertise"
            }
          ></textarea>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label w-100">
            Tools Used:
            <small style={{ float: "right" }}>
              {stateObj.tools?.length || 0} / 250
            </small>
          </label>
          <textarea
            className="form-control"
            readOnly={stateObj.activestatus !== "True"}
            style={{ minHeight: 100 }}
            onChange={(e) => {
              if (
                e.target.value.length <= 250 &&
                stateObj.activestatus === "True"
              )
                setStateObj({ ...stateObj, tools: e.target.value });
            }}
            value={stateObj.tools}
            placeholder={
              stateObj.activestatus !== "True" ? "Subscribe to Enter" : "Tools"
            }
          ></textarea>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label w-100">
          Certifications and Awards:
            <small style={{ float: "right" }}>
              {stateObj.certifications?.length || 0} / 250
            </small>
          </label>
          <textarea
            className="form-control"
            readOnly={stateObj.activestatus !== "True"}
            style={{ minHeight: 100 }}
            onChange={(e) => {
              if (
                e.target.value.length <= 250 &&
                stateObj.activestatus === "True"
              )
                setStateObj({ ...stateObj, certifications: e.target.value });
            }}
            value={stateObj.certifications}
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe to Enter"
                : "Relevant certifications"
            }
          ></textarea>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label w-100">
            Awards:
            <small style={{ float: "right" }}>
              {stateObj.awards?.length || 0} / 250
            </small>
          </label>
          <textarea
            className="form-control"
            readOnly={stateObj.activestatus !== "True"}
            style={{ minHeight: 100 }}
            onChange={(e) => {
              if (
                e.target.value.length <= 250 &&
                stateObj.activestatus === "True"
              )
                setStateObj({ ...stateObj, awards: e.target.value });
            }}
            value={stateObj.awards}
            placeholder={
              stateObj.activestatus !== "True" ? "Subscribe to Enter" : "Awards"
            }
          ></textarea>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label w-100" htmlFor="linkedin">
            Core Values / Philosophy:
            <small style={{ float: "right" }}>
              {stateObj.philosophy?.length || 0} / 250
            </small>
          </label>
          <textarea
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe To Enter"
                : "Core Values  / Philosophy"
            }
            readOnly={stateObj.activestatus !== "True"}
            className="form-control"
            style={{ minHeight: 100 }}
            onChange={(e) => {
              if (
                e.target.value.length <= 250 &&
                stateObj.activestatus === "True"
              )
                setStateObj({ ...stateObj, philosophy: e.target.value });
            }}
            value={stateObj.philosophy}
          ></textarea>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label w-100">
          Testimonials:
            <small style={{ float: "right" }}>
              {stateObj.csr?.length || 0} / 250
            </small>
          </label>
          <textarea
            className="form-control"
            readOnly={stateObj.activestatus !== "True"}
            style={{ minHeight: 100 }}
            onChange={(e) => {
              if (
                e.target.value.length <= 250 &&
                stateObj.activestatus === "True"
              )
                setStateObj({ ...stateObj, csr: e.target.value });
            }}
            value={stateObj.csr}
            placeholder={
              stateObj.activestatus !== "True" ? "Subscribe to Enter" : "Testimonials"
            }
          ></textarea>
        </div>
      </div>
      <div className="form-group">
        <button
          className="btn btn-primary "
          onClick={() => {
            UpdateProfile();
          }}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default AdditionalCompany;
